import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { menuMenuService } from "../../../services/menu-services/menuMenu.service";

const getAllMenuPacks = createAsyncThunk(
  "menuMenuSlice/getAllMenuPacks",
  async ({ currentData }, { rejectWithValue }) => {
    try {
      return await menuMenuService.getAllMenuPacks(currentData);
    } catch (e) {
      return rejectWithValue(
        e.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const createMenuPack = createAsyncThunk(
  "menuMenuSlice/createMenuPack",
  async (data, { rejectWithValue }) => {
    try {
      return await menuMenuService.createMenuPack(data);
    } catch (e) {
      return rejectWithValue(
        e.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const cloneMenuToDate = createAsyncThunk(
  "menuMenuSlice/cloneMenuToDate",
  async ({ sourceDate, targetDate }, { rejectWithValue }) => {
    try {
      return await menuMenuService.cloneMenuToDate(sourceDate, targetDate);
    } catch (e) {
      return rejectWithValue(
        e.response?.data?.message || "Something went wrong"
      );
    }
  }
);
const deleteMenuDish = createAsyncThunk(
  "menuMenuSlice/deleteMenuDish",
  async ({ menuId }, { rejectWithValue }) => {
    try {
      return await menuMenuService.deleteMenuDish(menuId);
    } catch (e) {
      return rejectWithValue(
        e.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const initialState = {
  menuMenuPacksArray: [],
  dataOfDay: null,
  idPackForBack: null,
  idPackMealForBack: null,
  idMatching: null,
  status: null,
  error: null,
  trigger: 0,
};

const menuMenuSlice = createSlice({
  name: "menuMenuSlice",
  initialState,
  reducers: {
    changeTrigger: (state, action) => {
      state.trigger = state.trigger + 1;
    },
    changeDataOfDay: (state, action) => {
      state.dataOfDay = action.payload;
    },
    changeId: (state, action) => {
      state.idPackForBack = action.payload;
    },
    changeIdForMeal: (state, action) => {
      state.idPackMealForBack = action.payload;
    },
    changeIdMatching: (state, action) => {
      state.idMatching = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getAllMenuPacks.pending, (state) => {
        state.status = "Loading";
        state.error = null;
      })
      .addCase(getAllMenuPacks.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.menuMenuPacksArray = action.payload;
      })
      .addCase(getAllMenuPacks.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase(createMenuPack.pending, (state) => {
        state.status = "Loading";
        state.error = null;
      })
      .addCase(createMenuPack.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.trigger = state.trigger + 1;
      })
      .addCase(createMenuPack.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase(cloneMenuToDate.pending, (state) => {
        state.status = "Loading";
        state.error = null;
      })
      .addCase(cloneMenuToDate.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.trigger = state.trigger + 1;
      })
      .addCase(cloneMenuToDate.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase(deleteMenuDish.pending, (state) => {
        state.status = "Loading";
        state.error = null;
      })
      .addCase(deleteMenuDish.fulfilled, (state) => {
        state.status = "fulfilled";
        state.trigger = state.trigger + 1;
      })
      .addCase(deleteMenuDish.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      }),
});

const { reducer: menuMenuReducer, actions } = menuMenuSlice;
const menuMenuActions = {
  ...actions,
  getAllMenuPacks,
  createMenuPack,
  cloneMenuToDate,
  deleteMenuDish,
};

export { menuMenuActions, menuMenuReducer };
